import React from 'react';
import { useLocation } from 'react-router-dom';
import { getOrgTermsContent } from '../../../../../content/utils.js';
import PageHeader from '../../../PageHeader.js';
import BreadCrumbs from '../../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../../icons/ProjectBreadcrumbIcon.jsx';
import { getTaskPage } from '../../../../../helpers/breadcrumbRouteHelpers.js';
import {
  ChangeImpactLink,
  ChangeImpactsLink,
  ProjectLink,
  ProjectsLink,
} from '../../../../links/index.jsx';

const TaskHeader = ({ changeImpact, project, task, slug }) => {
  const location = useLocation();
  const taskPage = getTaskPage(location.pathname);

  return (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        <ChangeImpactsLink projectId={project.id}>
          Change Impacts
        </ChangeImpactsLink>
        <ChangeImpactLink
          projectId={project.id}
          changeImpactId={changeImpact.id}
        >
          {changeImpact.title}
        </ChangeImpactLink>
        {taskPage === 'show' ? <span>{task.title}</span> : null}
        {taskPage === 'edit' ? <span>{task.title} Edit Task</span> : null}
        {taskPage === 'new' ? <span>Add Task</span> : null}
      </BreadCrumbs>
    </PageHeader>
  );
};

export default TaskHeader;
